import React, { useContext, useEffect, useState } from 'react';
import { Form } from 'informed';
import axios from 'axios';
import { API_HOST } from '../../consts';
import InputSelect from '../../components/inputs/InputSelect';
import { toast } from 'react-toastify';
import { withTheme } from 'styled-components';
import { Grid } from '@material-ui/core';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';
import { get } from 'lodash';

let FORM_INITIAL_STATE = {
  dreOptions: null,
  municipioOption: null,
  escolaOptions: null,
  ano: null,
  periodo: null,
  etapaOptions: null,
  turmaOptions: null,
  disciplinaOptions: null
};

const FilterRelatorio = ({ onFilterChange, buttonRelatorio, ...props }) => {
  const [state, setState] = useState({
    me: null,
    loading: true,
    isLoading: false,
    isPlaceholder: 'Selecione',
  });
  const { setStateFilters } = useContext(FilterRelatorioContext);
  const [formApi, setFormApi] = useState(null);
  const [formInputData, setFormInputData] = useState({});


  const performUpdate = (newData) => {
    setFormInputData((prevState) => ({ ...prevState, ...newData }))
  }

  const groups =
    state.me &&
    state.me.logged_group.map((f) => {
      return f.toUpperCase();
    });

  const host = window.location.host;
  const legenda = 'Rede de ensino';
  const restrictAcess = groups && groups.includes('ADMINISTRADOR') || groups && groups.includes('DRE');

  FORM_INITIAL_STATE = restrictAcess ? FORM_INITIAL_STATE : {
    dreOptions: null,
    escolaOptions: null,
    ano: null,
    periodo: null,
    etapaOptions: null,
    turmaOptions: null,
    disciplinaOptions: null
  };

  useEffect(() => {
    const mountFetchs = async () => {
      await fetchAno();
      await fetchMe();
      await fetchDre();
      setState((prevState) => {
        return { ...prevState, loading: false, isLoading: false };
      })
    }
    mountFetchs();
  }, []);

  useEffect(() => {
    if (formApi && formInputData.periodoAno) {
      fetchEtapaFiltered();
    }
  }, [formInputData.periodoAno]);

  const fetchDre = async () => {
    try {
      const response = await axios.get(`${API_HOST}/avalia/dre`)
      performUpdate({
        dreOptions: response && response.data.map((d) => ({
          ...d,
          value: d.external_id,
          label: d.dre_name,
          id: d.external_id,
        }))
      })
    } catch (error) {
      toast.error("Nenhum DRE encontrado");
      console.error(error.message);
    }
  };

  const fetchMunicipio = async (dreId) => {
    if (dreId) {
      try {
        performUpdate({ dreId: dreId.id })
        const response = await axios.get(`${API_HOST}/avalia/municipio?dre_id=${dreId.id}`)
        if (response.data.results.length === 0) {
          throw new Error('Nenhum município encontrado');
        }
        performUpdate({
          municipioOption: response && response.data.results.map((d) => ({
            value: d.cd_municipio,
            label: d.nm_municipio,
            ...d
          }))
        });
      } catch (error) {
        toast.error("Nenhum município encontrado");
        console.error(error.message);
      }
    };
  }

  const fetchEscola = async (dreId) => {
    if (dreId) {
      try {
        performUpdate({ dreId: dreId.id });
        const response = await axios.get(`${API_HOST}/avalia/escola?cd_municipio=${dreId.value}`)
        if (response.data.length === 0) {
          throw new Error('Nenhuma escola encontrada');
        }
        performUpdate({
          escolaOptions: response && response.data.map((d) => ({
            value: d.cd_escola,
            label: d.nm_escola,
            ...d
          }))
        });
      } catch (error) {
        toast.error("Nenhuma escola encontrada");
        console.error(error.message);
      }
    };
  }

  const fetchEtapaEscola = async (cdEscola) => {
    if (cdEscola) {
      try {
        const response = await axios.get(`${API_HOST}/avalia/escola_etapa?cd_escola=${cdEscola.value}`)
        if (response.data.results.length === 0) {
          throw new Error('Nenhuma etapa encontrada');
        }
        performUpdate({
          etapaOption: response && response.data.results.map((d) => ({
            value: d.nr_etapa,
            label: d.dc_etapa,
            ...d
          }))
        });
      } catch (error) {
        // toast.error("Nenhuma etapa encontrada"); #to do validar se faz sentido essa validação em algum contexto
        console.error(error.message);
      }
    }
  }

  const fetchAno = async () => {
    try {
      const response = await axios.get(`${API_HOST}/avalia/ano`);
      performUpdate({
        anoOptions: response.data.map((d) => ({
          value: d.id,
          label: d.ds_ano
        }))
      });
    } catch (error) {
      toast.error("Nenhum ano encontrado");
      console.error(error.message);
    }
  };

  const fetchPeriodo = async () => {
    setState(prevState => ({ ...prevState, isLoading: true }));
    try {
      const response = await axios.get(`${API_HOST}/avalia/periodo`);
      performUpdate({
        periodoOptions: response && response.data.map((d) => ({
          value: d.id,
          label: d.ds_periodo
        }))
      });
      setState(prevState => ({ ...prevState, isLoading: false }));
    } catch (error) {
      toast.error("Nenhum período encontrado");
      console.error(error.message);
    }
  };

  const fetchPeriodoAno = async () => {
    const { periodo, ano } = formApi.getState().values;
    setState(prevState => ({ ...prevState, isLoading: true }));
    try {
      const response = await axios.get(`${API_HOST}/avalia/periodo_ano?periodo__id=${periodo}&ano__id=${ano}`);
      performUpdate({
        periodoAno: response && get(response.data[0],'id'),
        periodo: periodo
      });
      setState(prevState => ({ ...prevState, isLoading: false }));
    } catch (error) {
      toast.error("Nenhum período ano encontrado");
      console.error(error.message);
    }
  };

  const fetchEtapaFiltered = async () => {
    const { periodoAno, escolaOptions } = formApi.getState().values;
    const params = {
      dre_id: formInputData.dreId,
      periodo_ano_id: formInputData.periodoAno,
      escolaOptions: escolaOptions
    }
    try {
      const response = await axios.get(`${API_HOST}/avalia/etapa-input`, { params })
      const data = response.data.map((d) => ({ value: d.nr_etapa, label: d.etapa, ...d }));
      performUpdate({ etapaOption: data });
    } catch (error) {
      toast.error(error);
    };

  };

  const fetchTurma = async (escolaId) => {
    const {
      periodo,
      nr_etapa,
      cd_etapa,
      escolaOptions: cd_escola,
    } = { ...formApi.getState().values, ...escolaId };

    if (escolaId) {
      performUpdate({ currentEscola: cd_escola, nrEtapa: nr_etapa, codigoEtapa: cd_etapa });
      try {
        const response = await axios.get(
          `${API_HOST}/avalia/turma?cd_escola=${cd_escola}&cd_etapa=${cd_etapa}&periodo_ano_id=${formInputData.periodoAno}`
        );
        performUpdate({
          turmaOptions: response && response.data.results.map((d) => ({
            value: d.cd_turma,
            label: '(' + d.nm_turma + ') ' + d.cd_turma,
            ...d
          }))
        });
      } catch (error) {
        toast.error("Nenhuma turma encontrada");
        console.error(error.message);
      }
    }
  };

  const fetchDisciplinas = async (disciplina) => {
    try {
      const response = await axios.get(`${API_HOST}/avalia/disciplina`);
      performUpdate({
        disciplinaOptions: response.data.results.map((d) => ({
          value: d.id,
          label: d.disciplina,
          ...d
        })),
        cd_turma: disciplina.cd_turma,
        currentEscola: disciplina.cd_escola
      })
    } catch (error) {
      toast.error("Nenhuma disciplina encontrada");
      console.error(error.message);
    }
  };

  const fetchDres = async (me) => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_HOST}/core/rede_dre_inst/${me}/get_dres`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      });
      performUpdate({
        dres: response.data.dre.map((d) => ({
          id: d.cd_dre,
          value: d.ds_dre,
          label: d.ds_dre,
          ...d
        }))
      });
    } catch (error) {
      toast.error("Nenhum DRE encontrado");
      console.error(error.message);
    }
  };

  const fetchDresAdm = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_HOST}/avalia/dre`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      });
      performUpdate({
        dres: response.data.map((d) => ({
          ...d,
          id: d.external_id,
          value: d.dre_name,
          label: d.dre_name,
        }))
      });
    } catch (error) {
      toast.error("Nenhum DRE encontrado");
      console.error(error.message);
    }
  };

  const fetchInstitution = async (me, dre) => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(
        `${API_HOST}/core/rede_dre_inst/get_escolas?user_group_instituicao__usuario=${me}&dre__cd_dre=${dre}`,
        {
          headers: {
            Authorization: `JWT ${token}`
          }
        }
      );
      if (response.data.length === 0) {
        throw new Error('Nenhuma escola encontrada');
      }
      performUpdate({
        escolaOptions: response.data.map((x) => ({
          value: x.instituicao.instituicao.codigo,
          label: x.instituicao.instituicao.descricao,
          ...x,
        }))
      });
    } catch (error) {
      setState(prevState => ({ ...prevState, isLoading: false }));
      toast.error("Nenhuma escola encontrada");
      console.error(error.message);
    }
  }

  const fetchMe = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      });
      setState(prevState => ({ ...prevState, me: response.data }));
      let groups = response.data.logged_group.map((f) => {
        return f.toUpperCase();
      });
      if (groups.includes('ADMINISTRADOR')) {
        fetchDresAdm();
      } else {
        fetchDres(response.data.id);
      }
    } catch (error) {
      toast.error("Dados de acesso não encontrados");
      console.error(error.message);
    }
  }

  const isValidForm = () => {
    let isValidForm = true;
    let formValues = formApi.getState().values;
    Object.keys(formValues).forEach((key) => {
      if (!isValidField(formValues[key])) {
        formApi.setError(key, ['O campo é obrigatório']);
        isValidForm = false;
      }
    });
    return isValidForm;
  }

  const submitForm = (e) => {
    e.preventDefault()
    if (isValidForm()) {
      setStateFilters({ ...formInputData, isFormSubmit: true });
    }
  }

  const isValidField = fieldValue => {
    if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
      return false;
    }
    return true;
  };

  return (
    <>
      {state.loading ? (
        <div
          style={{
            width: '100%',
            height: `100%`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img src={get(props.theme, "loadingGif")} alt="loading" style={{ height: '50px' }} />
        </div>) : (
        <div>
          <Form
            key={`form-${FORM_INITIAL_STATE.dreOptions}`}
            getApi={(formApi) => {
              setFormApi(formApi);
            }}
            initialValues={FORM_INITIAL_STATE}
          >
            <Grid
              container
              style={{
                ...(!restrictAcess && { justifyContent: 'flex-end' })
              }}>
              <Grid item xs={12} md={3}>
                <InputSelect
                  key='dreOptions-select'
                  label={legenda}
                  field='dreOptions'
                  onChange={(e) => {
                    if (restrictAcess) {
                      formApi.setValue('municipioOption', '');
                      fetchMunicipio(e)
                    } else {
                      formApi.setValue('escolaOptions', '');
                      fetchInstitution(state.me.id, e.id);
                    }
                  }}
                  options={formInputData.dres}
                  required={true}
                />
              </Grid>

              {restrictAcess &&
                <Grid item xs={12} md={3}>
                  <InputSelect
                    key={'municipioOption-select'}
                    label='Município'
                    field='municipioOption'
                    onChange={(e) => {
                      formApi.setValue('escolaOptions', '');
                      fetchEscola(e)
                    }}
                    options={formInputData.municipioOption}
                    required={true}
                  />
                </Grid>}

              <Grid item xs={12} md={6}>
                <InputSelect
                  key={'escolaOptions-select'}
                  label='Escola'
                  field='escolaOptions'
                  onChange={(e) => {
                    formApi.setValue('ano', '');
                    if (e) {
                      fetchEtapaEscola(e);
                      performUpdate({ escolaId: e.value })
                    }
                  }}
                  options={formInputData.escolaOptions}
                  required={true}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'ano-select'}
                  label='Ano'
                  field='ano'
                  onChange={(e) => {
                    formApi.setValue('periodo', '');
                    if (e) {
                      fetchPeriodo();
                      performUpdate({ ano: e.value });
                    }
                  }}
                  options={formInputData.anoOptions}
                  required={true}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'periodo-select'}
                  isLoading={state.isLoading}
                  label='Avaliação'
                  field='periodo'
                  onChange={(e) => {
                    formApi.setValue('etapaOptions', '');
                    if (e) {
                      performUpdate({ provas: e.value, periodo: e.value });
                      fetchPeriodoAno();
                    }
                  }}
                  options={formInputData.periodoOptions}
                  required={true}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'etapaOptions-select'}
                  label='Série/Ano '
                  field='etapaOptions'
                  onChange={(e) => {
                    formApi.setValue('turmaOptions', '');
                    fetchTurma(e);
                  }}
                  options={formInputData.etapaOption}
                  required={true}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'turmaOptions-select'}
                  label='Turma'
                  field='turmaOptions'
                  onChange={(e) => {
                    formApi.setValue('disciplinaOptions', '');
                    fetchDisciplinas(e);
                  }}
                  options={formInputData.turmaOptions}
                  required={true}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'disciplinaOptions-select'}
                  isLoading={state.isLoading}
                  label='Área do Conhecimento'
                  field='disciplinaOptions'
                  onChange={(e) => {
                    if (e) {
                      performUpdate({ DisciplinaID: e.value });
                    }
                  }}
                  options={formInputData.disciplinaOptions}
                  required={true}
                />
              </Grid>

              <Grid
                item xs={12} md={3}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  ...(!restrictAcess && {
                    justifyContent: 'end',
                    padding: '5px'
                  })
                }}>
                <button
                  id='submit-from'
                  style={{
                    color: 'white',
                    backgroundColor: props.theme.primary,
                    border: 'none',
                    fontSize: '16px',
                    fontWeight: '600',
                    textAlign: 'center',
                    cursor: 'pointer',
                    borderRadius: '15px',
                    boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                    letterSpacing: '1px',
                    padding: '4px 16px',
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginLeft: '10px',
                  }}
                  onClick={(e) => { submitForm(e) }}
                >
                  Gerar Relatório
                </button>
              </Grid>
            </Grid>
          </Form>
        </div>)}
    </>
  );
}
FilterRelatorio.contextType = FilterRelatorioContext;
export default withTheme(FilterRelatorio);
